import { IVUParamsSubCategory } from '../Redux/VisualUnits/vuParamSlice';
import { getVUFilterableObject, getVUMeasureObject } from '../Pages/Workspace/workspace';
import { FoundationsEnums } from '../enum';
import { ConvertFilterDisplayText, parseConvertedFilterDispText, TBpObject } from './VisualUnitParams/ConvertFilterDisplayText';
import { FilterValueOption } from '../GenericComponents/filterTypes';
import { IDimensionsCol, IFilters, Imeasures, T_VuParamsActionState } from './Reports/DashboardVuParams';
import React from 'react';
import { IVuParams } from '../Redux/VisualUnits/visualUnitStateSlice';
import { FoundationsConstants } from '../FoundationsConstants';
import {VisualUnitApiDTO_EditSaveVisualUnit} from '../Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit';

export interface ISetObjectForHLDate {
    setHLMonths?: any,
    setHLYears?: any,
    setMultipleDates?: any,
    setHLWeekdays?: any,
    setHLNumberValues?: any,
    setHLDurationValues?: any,
    setHLAgeValues?: any,
}
//FP-11927 - the below values should have default values as per the below and cannot be undefined in IHLreturnData

// HLTIME_FROM : "12:00 am"
// HLTIME_TO : "11:59 pm"
// HLDATE_PERIOD1: "today"
// HLDATETIME_PERIOD: "hours"
// HLDATE_RELATIVE_RANGE_3: "hours"
// HLDATE_RELATIVE_RANGE_5: "hours"
// HLDATE_PERIOD2: "week"
// HLDATE_PERIOD3: "month"
// HLDATE_YEAR: "1"
export interface IHLreturnData {
    HLDATE_FROM: any,
    HLDATE_TO: any,
    HLTIME_FROM: string,
    HLDATE_WEEKDAYS?: number[], //contain indexes of week days
    HLTIME_TO: string,
    HLDATE_PERIOD1: string,
    HLDATE_MULTIPLE_DATES?: string[],
    HLDATE_YEARS: any[],
    HLDATE_MONTHS: any[],
    HLNUMBER: number | null,
    HLDATETIME_NUMBER?: string | undefined,
    HLDATETIME_PERIOD: string,
    HLDATE_RELATIVE_RANGE_2?: string | undefined, //if not set by default then these values with ? optional chaining comes undefined
    HLDATE_RELATIVE_RANGE_3?: string,
    HLDATE_RELATIVE_RANGE_4?: string | undefined
    HLDATE_RELATIVE_RANGE_5?: string,
    HLDATE_New_RELATIVE_RANGE_1?: any,
    HLDATE_New_RELATIVE_RANGE_2?: string | undefined,
    HLDATE_New_RELATIVE_RANGE_3?: string | undefined,
    HLDATE_New_RELATIVE_RANGE_4?: string | undefined,

    HLDATE_PERIOD2: string,
    HLDATE_PERIOD3: string,
    HLDATE_YEAR: string,

    HLNUMBER_FROM?: string | undefined,
    HLNUMBER_TO?: string | undefined,

    HLDURATION_NUMBER?: string | undefined,
    HLDURATION_PERIOD?: string | undefined,
    HLDURATION_NUMBER_FROM?: string | undefined,
    HLDURATION_NUMBER_TO?: string | undefined,
    HLDURATION_PERIOD_FROM?: string | undefined,
    HLDURATION_PERIOD_TO?: string | undefined,

    HLAGE?: string | undefined,
    HLAGE_FROM?: string | undefined,

    HLAGE_TO?: string | undefined,
    HLTEXT?: string | undefined,

    HLMONEY?: string | undefined,
    HLMONEY_FROM?: string | undefined,
    HLMONEY_TO?: string | undefined,
}

export type IHLDataType = "HLDATE_FROM" |
    "HLDATE_TO" |
    "HLTIME_FROM" |
    "HLTIME_TO" |
    "HLDATE_PERIOD1" |
    "HLDATE_YEARS" |
    "HLDATE_MONTHS" |
    "HLNUMBER_FROM" |
    "HLNUMBER_TO"

export interface IFilterConditions {conditionType: string, conditionData: string[] | null}

export const isUpdateParamsCall=(action: T_VuParamsActionState) =>{
    return action === "updateMeasure" || 
    action === "updateFilter" || 
    action === "updateColumn" ||
    action === "updateRow"
}
export const isAddParmsCall=(action: T_VuParamsActionState) =>{
    return action === "addmeasure" || 
    action === "addfilter" || 
    action === "addcolumn" || 
    action === "addrow"
}
export const isMeasureCall=(action: T_VuParamsActionState) =>{
    return action === "addmeasure" || action === "updateMeasure" 
}
export const isFilterCall=(action: T_VuParamsActionState) =>{
    return action === "addfilter" || action === "updateFilter" 
}
export const isDimensionColcall=(action: T_VuParamsActionState) =>{
    return action === "addcolumn" || action === "updateColumn" 
}
export const isDimensionRowcall=(action: T_VuParamsActionState) =>{
    return action === "addrow" || action === "updateRow" 
}
export const isDimensioncall=(action: T_VuParamsActionState) =>{
    return action === "addrow" || action === "updateRow" ||  action === "addcolumn" || action === "updateColumn"
}
export const checkDimensionsCount = (paramsCall: T_VuParamsActionState, vuObject: VisualUnitApiDTO_EditSaveVisualUnit) => {
    //even though its not close dialog call, if the dimension counts reached to 2 the dialog must close (release branch behaviour)
    let closeDialog = false
    let rowsLength = vuObject.dimensionRow.length
    let columnsLength = vuObject.dimensionCol.length
    if (paramsCall === "addcolumn") {
        if (columnsLength === 1) { //after add successfull it will become 2, so need to close dialog
            closeDialog = true
        }
    } else if (paramsCall === "addrow") {
        if (rowsLength === 1) { //after add successfull it will become 2, so need to close dialog
            closeDialog = true
        }
    }
    return closeDialog
}

export const checkIsInvalidFilter =(genericFilterValues: any, selectedCheckboxValues: any, businessParamChecked: any, bpObjectRef: any) =>{
    let isValidFilter = true; //valid filter values
    if (
        genericFilterValues !== null ||
        selectedCheckboxValues.length > 0 || 
        (businessParamChecked === 1 && bpObjectRef !== null)
    ) {
        isValidFilter = false //invalid filter values
    }
    return isValidFilter 

}

export const checkIsInvalidDimension =(selectedLeftItem: IVUParamsSubCategory) =>{
    let isInValidDimension = true; //valid filter values
    if (
        selectedLeftItem?.FieldKey !== undefined
    ) {
        isInValidDimension = false //invalid filter values
    }
    return isInValidDimension 
}

export const formattedFilterString = (names: string[], condition: string) => {
    const [action, match] = condition.split("_").map((word, index) =>
        index === 0 ? word[0].toUpperCase() + word.slice(1).toLowerCase() : word.toLowerCase()
    );

    // Join names with '; ' separator
    let namesList = names.join("; ");
    if (namesList.length > 157) {
        namesList = namesList.slice(0, 157) + "..."; // Truncate if too long as per previous branch
    }

    // Format and return the string
    return `${action} ${match} of [${namesList}]`;
}

export function formatFlatString(values: string[]) {
    return values
        //.map(values => values.replace(/,/g, "_")) // Replace all commas in each name with underscores  //...
        // This is not needed — there is a semicolon (;) between the two values, not a comma (,), which is why it affects pre-existing filter values that contain commas.
        .join("__"); // Join the names with space
}

export function getCheckedFilterValues(filterValue: string, filterDisplayText: string) {
    // filterDisplayText for e.g. Include any of [H; L]
    //we are extracting [H, L] so that we can set default checked for checkbox
    if (filterValue) {
        return filterValue
            .split("__")
    }
    const extractText = filterDisplayText.match(/\[([^\]]+)\]/);

    const values = extractText ? extractText[1].split("; ").map(item => item.trim()) : [];

    return values
}
export const helperFormDimensionItem = (selectedBin: any, selectedLeftItem: IVUParamsSubCategory | null) => {
    let formedDimensionItem: any = {}
    formedDimensionItem.binName = selectedBin?.Name || '- no bin -'
    formedDimensionItem.dimensionName = selectedLeftItem?.FieldName
    formedDimensionItem.metaDataId = selectedBin?.Id
    formedDimensionItem.Id = selectedLeftItem?.FieldKey
    formedDimensionItem.MetaDataBinId = selectedBin?.Id || 0
    formedDimensionItem.MetaData = selectedLeftItem
    return formedDimensionItem
}

export const helperFormMeasureItem = (type: "singleValueItem" | "businessParameterItem" | "aggricateItem", action: string, payload: any = {}, selectedLeftItem: IVUParamsSubCategory | any = {}, selectedAggirateItem: any = {}) => {
    let formedMeasureItem: any = getVUMeasureObject()
    formedMeasureItem.measureSetId = -1
    switch (type) {
        case "singleValueItem":
            formedMeasureItem.aggregateFunction = selectedAggirateItem.name;
            formedMeasureItem.subCategoryName = selectedLeftItem.FieldName;
            formedMeasureItem.categoryName = selectedLeftItem.CategoryName;
            formedMeasureItem.compCategoryName = selectedLeftItem.ComputedCategoryName;
            formedMeasureItem.factGroup = selectedLeftItem.FactGroupName
            formedMeasureItem.id = selectedLeftItem.FieldKey;
            formedMeasureItem.singleValueReportId = selectedAggirateItem.id;
            formedMeasureItem.displayOrder = selectedLeftItem.DisplayOrder
            formedMeasureItem.axisSubType = FoundationsEnums.AxisSubType.SVR
            formedMeasureItem.MetaData = selectedLeftItem
            break;

        case "businessParameterItem":
            formedMeasureItem.aggregateFunction = selectedAggirateItem?.Name || "";
            formedMeasureItem.subCategoryName = selectedLeftItem.FieldName;
            formedMeasureItem.categoryName = selectedLeftItem.CategoryName;
            formedMeasureItem.compCategoryName = selectedLeftItem.ComputedCategoryName;
            formedMeasureItem.factGroup = selectedLeftItem.FactGroupName
            formedMeasureItem.id = selectedLeftItem.FieldKey;
            formedMeasureItem.displayOrder = selectedLeftItem.DisplayOrder
            formedMeasureItem.businessParameterId = selectedAggirateItem.Id
            formedMeasureItem.axisSubType = FoundationsEnums.AxisSubType.BP
            formedMeasureItem.MetaData = selectedLeftItem
            break;

        case "aggricateItem":
            formedMeasureItem.aggregateFunction = selectedAggirateItem.AggregateFunction;
            formedMeasureItem.subCategoryName = selectedLeftItem.FieldName;
            formedMeasureItem.categoryName = selectedLeftItem.CategoryName;
            formedMeasureItem.compCategoryName = selectedLeftItem.ComputedCategoryName;
            formedMeasureItem.factGroup = selectedLeftItem.FactGroupName
            formedMeasureItem.id = selectedLeftItem.FieldKey;
            formedMeasureItem.displayOrder = selectedLeftItem.DisplayOrder
            formedMeasureItem.MetaData = selectedLeftItem
            break
    }

    return formedMeasureItem
}

export const helperFormFilterItem = (inputsFromDuration: any = null, selectedLeftItem: any, selectedCheckboxValues: any[], filterValueOption: FilterValueOption, isBusinessParameter: 0 | 1, bpObject: TBpObject = null) => {
    let formedFilterItem: any = getVUFilterableObject()
    if (inputsFromDuration) { //case for date filter etc...
        let bpId = bpObject !== null ? (Object.keys(bpObject).length === 1 ? bpObject[Object.keys(bpObject)[0]].Id : Object.keys(bpObject).length > 1 ? undefined : 0) : undefined 
        //bpId=> Its the Id of a business parameter,
        // When single Business parameters are there Id will be first bpId, 
        // when multiple business parameteres are there Id will be undefined,
        // when No business parameters are there 0 will be bpId
        
        let result = ConvertFilterDisplayText(inputsFromDuration?.displayText, inputsFromDuration.selectedValues, isBusinessParameter, bpObject)
        formedFilterItem.filterDisplayText = result?.displayText
        formedFilterItem.displayOrder = 2
        formedFilterItem.categoryName = selectedLeftItem?.FieldName
        formedFilterItem.id = inputsFromDuration.id
        formedFilterItem.filterValueListId = inputsFromDuration.keyValue   
        formedFilterItem.filterValue = result?.displayTextValue
        formedFilterItem.MetaData = selectedLeftItem
        formedFilterItem.InputFilterType = isBusinessParameter
        formedFilterItem.bpId = bpId
    } else {
        let selectedCheckboxVals: string[] = []
        selectedCheckboxValues.forEach((itr) => { selectedCheckboxVals.push(itr.DisplayText) })
        formedFilterItem.displayOrder = 0, //its handled already at the time of calling api..
        formedFilterItem.filterDisplayText = formattedFilterString(selectedCheckboxVals, filterValueOption)
        formedFilterItem.filterOptions = filterValueOption
        formedFilterItem.filterValue = formatFlatString(selectedCheckboxVals)
        formedFilterItem.id = selectedLeftItem?.FieldKey
        formedFilterItem.categoryName = selectedLeftItem?.FieldName
        formedFilterItem.MetaData = selectedLeftItem
        formedFilterItem.InputFilterType = isBusinessParameter
    }
    return formedFilterItem
}

export const formedErrorText = (paramsAction: T_VuParamsActionState, noParams: boolean = false, currentState: any, selectedLeftItem: any = null) => {
    let formedErrorString = ""
    let currentDataType = selectedLeftItem?.DataType //no any category selected
    let HL_SearchList_HLList = [4, 5] //HLList, HLSearchList filter
    let HlDateFilterType = [10] //Date type filter
    console.log('Error function  currentDataType=>', currentDataType)
    switch (paramsAction) {
        case "addmeasure":
        case "updateMeasure":
            if (!currentDataType) {
                formedErrorString = "Please select a measure and try again."
            } else {
                if (noParams) {
                    formedErrorString = "Please select a value and try again."
                } else if (currentState === 'error') {
                    formedErrorString = "Duplicate measure cannot be added to the report. Please edit the exisiting measure in the report."
                } else {
                    formedErrorString = "Measure added successfully. Click OK to add more measures or click close."
                }
            }
            break;

        case "addfilter":
        case "updateFilter":
            if (!currentDataType) {
                formedErrorString = FoundationsConstants.NO_DATA_TYPE
            } else {
                if (noParams) {//Category selected but Filter not selected
                    if (HL_SearchList_HLList.includes(currentDataType)) {
                        formedErrorString = FoundationsConstants.NO_CHECKBOX_VALUE
                    } else if (HlDateFilterType.includes(currentDataType)) {
                        formedErrorString = FoundationsConstants.FILTER_EMPTY_Date_INPUT
                    } else {
                        formedErrorString = FoundationsConstants.NO_FilterSelected
                    }
                } else if (currentState=== 'error') { //duplicate found
                    formedErrorString = FoundationsConstants.DUPLICATE_FILTER
                } else { //case for Successfully added
                    formedErrorString = FoundationsConstants.FILTER_ADDED_SUCCESS
                }
            }
            break;
        // case "updateFilter":
        //     noParams ?
        //     formedErrorString = "Please select a filter value and try again." :
        //     formedErrorString = "Duplicate filter cannot be added to the report. Please edit the exisiting measure in the report."
        //     break;
        case "addcolumn":
        case "updateColumn":
            noParams ?
            formedErrorString = "Please select a dimension and try again." :
            formedErrorString = "Duplicate dimension(col) cannot be added to the report. Please edit the exisiting dimension in the report."
            if(currentState === 'success' && paramsAction !== "updateColumn") {
                formedErrorString = "Dimension(col) added successfully. Click OK to add more dimensions or click close."
            }

            break;
        case "addrow":
        case "updateRow":
            noParams ?
            formedErrorString = "Please select a dimension and try again." :
            formedErrorString = "Duplicate dimension(row) cannot be added to the report. Please edit the exisiting dimension in the report."
            if(currentState === 'success' && paramsAction !== "updateRow") {
                formedErrorString = "Dimension(Rows) added successfully. Click OK to add more dimensions or click close."
            }
            break
    }
    return formedErrorString
}


export const validateParams = (selectedLeftItem: any, paramsAction: T_VuParamsActionState, selectedAggricateFn: string, availMeasures: any[], updateIndex: number | null, onClose: Function, selectedBin: any = null, currentHLDataType: string = "",NoBinAvailable:any) => {
    let isValidate: boolean = true;
    if(Object.keys(selectedLeftItem).length === 0){
        isValidate = false
        return isValidate
    }
    switch (paramsAction) {
        case "addmeasure":
        case "updateMeasure":
            isValidate = validateAddMeasures(selectedLeftItem, selectedAggricateFn, paramsAction, availMeasures, updateIndex, onClose)
            break;
        case "addrow":
        case "updateRow":
        case "addcolumn":
        case "updateColumn":
            isValidate = validateAddDimension(selectedLeftItem, selectedAggricateFn, paramsAction, availMeasures, updateIndex, onClose, selectedBin ,NoBinAvailable)
            break;
        case "addfilter":
        case "updateFilter":
            isValidate = validateAddFilter(selectedLeftItem, selectedAggricateFn, paramsAction, availMeasures, updateIndex, onClose,currentHLDataType)
    }
    return isValidate
}
export const getMessageStatusFieldMsg = (status: any, fieldName: string) => {
    let fieldMsg = ''
    if (Object.keys(status).length > 0) {
        let messageResults = status
        if (messageResults?.Field === fieldName) {
            return (fieldMsg = messageResults.Message)
        }
    }
    return fieldMsg
}

export const validateAddMeasures = (formedMeasureItem: any, selectedAggricateFn: string | undefined, paramsAction: T_VuParamsActionState, availMeasures: any[], updateIndex: number | null, onClose: Function) => {
    let isValidate: boolean = true;
    if(!selectedAggricateFn) {
        isValidate = false
        return isValidate
    }
    //FieldKey
    if (isUpdateParamsCall(paramsAction) && updateIndex !== null) {
        //TODO: validation In case of update
        let currentMeasure = availMeasures[updateIndex]
        // let currSelectedAggrFnName =  currentMeasure?.aggegrateFunctionName
        if (formedMeasureItem.FieldKey === currentMeasure.metaDataId) { // same aggrigate function
            if (currentMeasure.aggegrateFunctionName === selectedAggricateFn) {
                onClose()
                isValidate = true
            } else {
                availMeasures.forEach((itr: Imeasures) => {
                    if (itr.metaDataId === formedMeasureItem.FieldKey && itr.aggegrateFunctionName === selectedAggricateFn) {
                        isValidate = false
                        return
                    }
                })
            }
        } else { // incase other aggricate function than previously selected
            availMeasures.forEach((itr: Imeasures) => {
                if (itr.metaDataId === formedMeasureItem.FieldKey && itr.aggegrateFunctionName === selectedAggricateFn) {
                    isValidate = false
                    return
                }
            })
        }
    } else {
        //validation in case of Add
        if (availMeasures?.length) {
            availMeasures.forEach((itr: Imeasures) => {
                if (itr.metaDataId == formedMeasureItem.FieldKey && itr.aggegrateFunctionName === selectedAggricateFn) {
                    isValidate = false
                    return
                }
            })
        }
    }
    return isValidate as boolean
}

export const validateAddDimension = (formedMeasureItem: any, selectedAggricateFn: string | undefined, paramsAction: T_VuParamsActionState, availMeasures: any[], updateIndex: number | null, onClose: Function, selectedBin: any,NoBinAvailable:any) => {
    let isValidate: boolean = true;
    if (isUpdateParamsCall(paramsAction) && updateIndex !== null) {
        let currentBin = availMeasures[updateIndex]
        if (formedMeasureItem.FieldKey === currentBin?.MetaData.FieldKey) {
            if (currentBin.binName === selectedAggricateFn) { // same aggrigate function
                onClose()
                isValidate = true
            } else {
                availMeasures.forEach((itr: IDimensionsCol) => {
                    if (itr.metaDataId === formedMeasureItem.FieldKey && itr.binName === selectedAggricateFn) { //FIXME: in progress Bin...
                        isValidate = false
                    }
                })
            }
        } else { // incase other aggricate function than previously selected
            availMeasures.forEach((itr: IDimensionsCol) => {
                if (itr.metaDataId === formedMeasureItem.FieldKey && itr.binName === selectedAggricateFn) {
                    isValidate = false
                }
            })
        }
    } else {
        //validation in case of Add
        if(NoBinAvailable ==false){
        let binId = selectedBin?.Id;
        if (availMeasures?.length) {
            availMeasures.forEach((itr: IDimensionsCol) => {
                if (itr.MetaData.FieldKey === formedMeasureItem.FieldKey && itr.metaDataId == binId) { //TODO: give check for binId insted of binName
                    isValidate = false
                }
            })
        }
    }
    else{
        isValidate=true;
    }
    }
    return isValidate as boolean
}

const validateAddFilter = (formedFilterItem: any, selectedAggricateFn: string | undefined, paramsAction: T_VuParamsActionState, availFilters: any[], updateIndex: number | null, onClose: Function, currentHLDataType: string = "") => {
    let isValidate: boolean = true; //true means failure of validations.
    if (isUpdateParamsCall(paramsAction) && updateIndex !== null) {
        let currentFilterItem = availFilters[updateIndex]
        if (formedFilterItem.FieldKey === currentFilterItem?.MetaData.FieldKey) {
            //search within the current filter
            isValidate = true
        } else { // incase other aggricate function than previously selected
            availFilters.forEach((itr: IDimensionsCol) => {
                if (itr.metaDataId === formedFilterItem.FieldKey) {
                    isValidate = false
                }
            })
        }
    } else {
        //validation in case of Add
        if(currentHLDataType === FoundationsConstants.HLDATATYPE.HLDate){ // user can add multiple date related filters, confirmed from Release branch behaviour and QA
            isValidate = true
            return isValidate
        }

        if (availFilters?.length) {
            availFilters.forEach((itr: IFilters) => {
                if (itr.MetaData.FieldKey === formedFilterItem.FieldKey) { //TODO: give check for binId insted of binName
                    isValidate = false
                }
            })
        }
    }
    return isValidate as boolean
}

export const validateGenericFilterValues = (formedFilterItem: {
    id: number
    displayOrder: number
    filterValue: string
    filterValueListId: string
    filterDisplayText: string
    filterOptions: string
    InputFilterType: number
    categoryName: string
    MetaData: any
  }, genericFilterVal: any, isBusinessParameter: 0 | 1 ) =>{

    if(genericFilterVal !== null){
        if((formedFilterItem.filterDisplayText.includes("[]")) || 
        formedFilterItem.filterDisplayText.includes("null") || 
        formedFilterItem.filterDisplayText.includes("undefined") ||
        formedFilterItem.filterDisplayText.includes("NaN") ||
        formedFilterItem.filterDisplayText === (" ") || !formedFilterItem.filterDisplayText ){
            return false
        }
    }
    return true
}

export const updateDisplayOrder = (indexedVuOj: VisualUnitApiDTO_EditSaveVisualUnit) =>{
    //this function make sure that correct displayOrder is being updated as per entries in array
    const updateOrder = (arr?: any[]) => 
        Array.isArray(arr) ? arr.map((item, index) => ({ ...item, displayOrder: index })) : [];

    return {
        ...indexedVuOj,
        measures: updateOrder(indexedVuOj.measures),
        filterable: updateOrder(indexedVuOj.filterable),
        dimensionRow: updateOrder(indexedVuOj.dimensionRow),
        dimensionCol: updateOrder(indexedVuOj.dimensionCol)
    };
}

export const updateDurationsFilterInputs = (setState: any, HLDataType: string, selectedParameters: any, additionalSetStates:ISetObjectForHLDate={}) => {
    try {
        //HLDATE
        let parsedData: IHLreturnData = parseConvertedFilterDispText(
            selectedParameters.displayText,
            selectedParameters.data.filterableValueDisplay,
            selectedParameters.data.filterValue
        ) as IHLreturnData;
        const stateUpdaters: Record<string, (data: IHLreturnData) => void> = {
            HLTEXT: (data) => setState({ HLTEXT: data.HLTEXT || undefined }),
            HLDURATION: (data) =>
                setState({
                    HLDURATION_NUMBER: data.HLDURATION_NUMBER || "",
                    HLDURATION_PERIOD: data.HLDURATION_PERIOD || "",
                    HLDURATION_NUMBER_FROM: data.HLDURATION_NUMBER_FROM || "",
                    HLDURATION_NUMBER_TO: data.HLDURATION_NUMBER_TO || "",
                    HLDURATION_PERIOD_FROM: data.HLDURATION_PERIOD_FROM || "",
                    HLDURATION_PERIOD_TO: data.HLDURATION_PERIOD_TO || "",
                }),
            HLDATE: (data) =>{
                setState({
                    HLDATE_FROM: data.HLDATE_FROM || "",
                    HLDATE_TO: data.HLDATE_TO || "",
                    HLTIME_FROM: data.HLTIME_FROM || "12:00 am",
                    HLTIME_TO: data.HLTIME_TO || "11:59 pm",
                    HLDATE_PERIOD1: data.HLDATE_PERIOD1 || "today",
                    HLDATE_PERIOD2: data.HLDATE_PERIOD2 || "week",
                    HLDATE_PERIOD3: data.HLDATE_PERIOD3 || "month",
                    HLDATE_YEARS: data.HLDATE_YEARS || [],
                    HLDATE_MONTHS: data.HLDATE_MONTHS || [],
                    HLNUMBER: data.HLNUMBER || "",
                    HLDATETIME_PERIOD: data.HLDATETIME_PERIOD || "hours",
                    HLDATE_YEAR: data.HLDATE_YEAR || "1",
                    HLDATE_MULTIPLE_DATES: data.HLDATE_MULTIPLE_DATES || [],
                    HLDATE_WEEKDAYS: data.HLDATE_WEEKDAYS || [],
                    HLDATETIME_NUMBER: data.HLDATETIME_NUMBER || undefined,

                    HLDATE_RELATIVE_RANGE_2: data.HLDATE_RELATIVE_RANGE_2 || '0',
                    HLDATE_RELATIVE_RANGE_3: data.HLDATE_RELATIVE_RANGE_3 || "hours",
                    HLDATE_RELATIVE_RANGE_4: data.HLDATE_RELATIVE_RANGE_4 || '0',
                    HLDATE_RELATIVE_RANGE_5: data.HLDATE_RELATIVE_RANGE_5 || "hours",

                    HLDATE_New_RELATIVE_RANGE_2: data.HLDATE_New_RELATIVE_RANGE_2 ?? "",
                    HLDATE_New_RELATIVE_RANGE_3: data.HLDATE_New_RELATIVE_RANGE_3 ?? "",
                    HLDATE_New_RELATIVE_RANGE_1: data.HLDATE_New_RELATIVE_RANGE_1 ?? "",
                });

            additionalSetStates.setMultipleDates(data.HLDATE_MULTIPLE_DATES || []);
            additionalSetStates.setHLMonths(data.HLDATE_MONTHS || []);
            additionalSetStates.setHLYears(data.HLDATE_YEARS || []);
            additionalSetStates.setHLWeekdays(data.HLDATE_WEEKDAYS || []);
            },

            HLAGE: (data) => //done
                setState({
                    HLAGE: data.HLAGE || "",
                    HLAGE_FROM: data.HLAGE_FROM || "",
                    HLAGE_TO: data.HLAGE_TO || "",
                }),

            HLCOUNT: (data: any) =>
                setState({
                    HLCOUNT: data.HLCOUNT || "",
                    HLCOUNT_FROM: data.HLCOUNT_FROM || "",
                    HLCOUNT_TO: data.HLCOUNT_TO || "",
                }),

            HLMONEY:(data: any) =>{
            setState({
                HLMONEY: data.HLMONEY || "",
                HLMONEY_FROM: data.HLMONEY_FROM || "",
                HLMONEY_TO: data.HLMONEY_TO || "",
            })},
            HLNUMBER:(data: any) =>{
                setState({
                    HLNUMBER: data.HLNUMBER || "",
                    HLNUMBER_FROM: data.HLNUMBER_FROM || "",
                    HLNUMBER_TO: data.HLNUMBER_TO || "",
                })},
        };

        if (HLDataType in stateUpdaters) {
            stateUpdaters[HLDataType](parsedData);
        } else {
            console.warn(`No handler defined for HLDataType: ${HLDataType}`);
        }
    } catch (err) {
        console.error(`Error fetching selected Params ${HLDataType}`, err);
    }
};